export default __webpack_public_path__ + "fde0d8d6235fbdb6a4e714574ed91a8b.png";